import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FolderInfoCardProps } from '../types';

/**
 * Displays folder metadata information (provider, name, file count, size)
 */
export const FolderInfoCard: React.FC<FolderInfoCardProps> = ({ folderInfo }) => {
  const { t } = useTranslation();

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          {t('shareFolder.folderInformation')}
        </Typography>
        <Typography variant="h6">
          {folderInfo.folderName}
        </Typography>
        <Box display="flex" gap={2} mt={1}>
          <Chip
            size="small"
            label={`${folderInfo.fileCount} files`}
            variant="outlined"
          />
          <Chip
            size="small"
            label={`${(folderInfo.totalSize / 1024 / 1024).toFixed(1)} MB`}
            variant="outlined"
          />
        </Box>
      </CardContent>
    </Card>
  );
};
